const VacuumIcon = ({className, pathClassName})=>
<svg className={className}
     viewBox="0 0 361 371">
 <path className={pathClassName} d="M221 287a42 42 0 1 0 0 84 42 42 0 0 0 0-84Zm140-146c0-9-10.5-18.3-10.5-18.3l-28 19.8C304.3 114 279.6 93 249 89.3a98.4 98.4 0 0 0-196 9v204h-5.7v16.4h-4L0 348.6V364h135.3v-15.4l-43.4-29.8h-4v-16.5h-7.4v-204a70.7 70.7 0 0 1 141-7.4c-34.6 9.5-46.7 54-46.7 188.7 0 4 .2 8 .5 11.7a59.2 59.2 0 1 1 91.3 75.6h3.6c48.2 0 90.8-39 90.8-87.3 0-33.2-7.6-72.4-22.4-106.5 9.3-10.4 22.4-26.3 22.4-32Z"/>
</svg>

export default VacuumIcon